
// **************************************************
//
// IMPORTS
//
// **************************************************

// console.warn = ()=> {}

// LIBRARIES
const THREE = require('three')
import _ from 'lodash'
import lerp from 'lerp'

import {TweenMax, TimelineMax, Cubic, Expo, SlowMo, CustomEase, Power1} from 'gsap'
require('src/lib/Maf')
import * as STAGES from './stages'
import * as colors from './colors'

// STORE, ROUTER, TRANSLATIONS
import store from 'src/store'
import router from 'src/router'
import i18n from 'src/i18n'

// GAME
import * as renderer from './renderer'
import * as controls from './controls'
// import * as orientation from './orientation'
import * as lights from './lights'
import * as clock from './clock'
import camera from './camera'
import uiCamera from './camera-ui'
import * as loader from './loader'
import scene from './scene'
import raf from './raf'
import config from './config'
import fog from './fog'

// UI
import * as textService from './ui/text-simple'
import * as ctaService from './ui/cta'
import * as countdown from './ui/countdown'
import * as distance from './ui/distance'
import * as scrollCta from './ui/scrollCta'
import * as ui from './ui/scene'
import * as eyelid from './ui/eyelid'
import dashboard from './ui/dashboard'

// OBJECTS
import {path, getPath} from './track-tiled/path'
// import {scalePath} from './track-tiled/scalePath'
import * as track from './track-tiled'
import Player from './runner/player'
// import Runner from './runner/runner'
import Runner from './runner/runner-morph'
import sky from './objects/sky'
import buildings from './objects/buildings'
import Car from './runner/car'
import Bike from './runner/bike'
import Horse from './runner/horse'

// EFFECTS
// import * as confetti from './effects/confetti'
import ConfettisShader from './effects/confettisShader'
import * as smoke from './effects/smoke'
// import RunningEffect from './effects/runningEffect'
import SpeedLines from './effects/speedLines'

// MUSIC
import * as music from './music'

// SOUND
import listener from './listener'
import sounds from './sounds'

// RESULT

import * as resultScene from './result/scene'
import * as resultBg from './result/bg'
import * as resultFlag from './result/flag'
import * as resultCloth from './result/cloth'


// **************************************************
//
// PLAYER
//
// **************************************************
export let player = new Player({
  path: path,
  distance: config.introDistance
})
scene.add(player.mesh)
// player.mesh.add(lights.dirLight)
lights.dirLight.target = player.mesh
player.mesh.add(lights.ptLight2)


// console.log(scalePath(1.2))


// **************************************************
//
// SPEED EFFECT
//
// **************************************************
let speedWorldEase = CustomEase.create('custom', 'M0,0 C0,0 0.012,0.183 0.042,0.448 0.05,0.522 0.06,0.673 0.074,0.71 0.078,0.721 0.114,0.894 0.154,0.908 0.253,0.916 0.358,0.913 0.5,0.914 0.639,0.914 0.824,0.916 0.852,0.904 0.908,0.886 0.926,0.712 0.93,0.702 0.945,0.665 0.949,0.518 0.958,0.444 0.987,0.179 1,0 1,0')






// **************************************************
//
// RUNNERS
//
// **************************************************
let offsets = []
for (let i = 0; i < config.numRunners; i++) {
  // let offset = i % (config.maxRunnerOffset * 2)
  let offset = i
  offset -= config.maxRunnerOffset * 2
  if (offset >= 0) {
    offset += 1
  }
  offsets.push(offset)
}
// console.log('OFFSETS', offsets)

export let runners = []
for (let i = 0; i < config.numRunners; i++) {

  let row = Math.floor(i / (config.maxRunnerOffset * 2)) + 1

  // DISTANCE BACK
  let dOffset = row * 0.001 // + i * 0.0005
  const d = config.startDistance - dOffset

  // LEFT / RIGHT OFFSET
  let offset = offsets.splice(window.Maf.randomInRange(0, offsets.length), 1)[0]
  // offset *= config.runnerOffset

  // MIN VELOCITY
  let minVel = config.cpuVel.min + ((i + 1) / config.numRunners) * 2

  // MAX VELOCITY
  let maxVel = config.cpuVel.min + (config.cpuVel.max - config.cpuVel.min) * ((i + 1) / config.numRunners)

  // console.log('vel', minVel, maxVel)
  // console.log(offset)

  // CONFIG
  let runnerConfig = {
    isPlayer: false,
    idx: i,
    type: (i % 2) === 0 ? 'male' : 'female',
    // path: path,
    path: getPath(offset),
    distance: d,
    distanceStart: d,
    minVel: minVel,
    maxVel: maxVel,
    // offset: offset * config.worldScale
    offset: 0
  }

  // if (i < 3) {
  //   runnerConfig.isPacer = true
  //   let time = 40 + (10 * i)
  //   runnerConfig.maxVel = config.totalPx / time / 1000
  // }

  let runner = new Runner(runnerConfig)
  runner.state.autoUpdateState = true
  scene.add(runner.mesh)
  runners.push(runner)
}


// ELITE RUNNERS - REUSE OLD RUNNERS
let maleRunners = _.filter(runners, (runner)=> {
  return runner.state.type === 'male'
})
export let elites = _.sortBy(maleRunners, (runner)=> {
  return runner.state.maxVel
})
elites = elites.splice(0, 3)



// ELITE RUNNERS - CREATE NEW RUNNERS
// export let elites = []
// let maleRunners = _.filter(runners, (runner)=> {
//   return runner.state.type === 'male' && !runner.state.isPacer
// })
// let elites = _.sampleSize(maleRunners, 3)

// let elites = []
// for (let i = 0; i < 3; i++) {

//   let row = Math.floor(i / (config.maxRunnerOffset * 2))

//   // DISTANCE
//   const d = config.startDistance

//   // LEFT / RIGHT OFFSET
//   let offset = (i - 1) * config.runnerOffset * 1.3

//   // MIN VELOCITY
//   let minVel = config.velocityMin + 10

//   // MAX VELOCITY
//   let maxVel = 170 + (10 * i)

//   let runner = new Runner({
//     isPlayer: false,
//     isElite: true,
//     idx: i,
//     type: 'elite',
//     path: path,
//     distance: d,
//     distanceStart: d,
//     minVel: minVel,
//     maxVel: maxVel,
//     offset: offset * config.worldScale,
//     multiplyVelocity: 1.01,
//     autoUpdateState: false
//   })
//   scene.add(runner.mesh)
//   runners.push(runner)
//   elites.push(runner)
// }



// **************************************************
//
// VEHICLES
//
// **************************************************

// CAR
let car = new Car({
  path: path,
  distance: config.stage1Length + config.stage2Length + 0.05
  // distance: 1.005
})
car.model.position.x = 5.3 * config.worldScale
scene.add(car.mesh)

// BIKE
let bike = new Bike({
  path: path,
  distance: config.stage1Length + config.stage2Length + 0.03
  // distance: 1.005
})
bike.model.position.x = -3.2 * config.worldScale
scene.add(bike.mesh)


// HORSE
// let maxVel = config.cpuVel.min + (config.cpuVel.max - config.cpuVel.min) * ((0 + 1) / config.numRunners)
// let horse = new Horse({
//   path: path,
//   type: 'male',
//   distance: config.startDistance + 0.01,
//   distanceStart: config.startDistance + 0.01,
//   minVel: config.velocityMin + 5,
//   maxVel: maxVel,
//   offset: 0,
//   multiplyVelocity: 1.01,
//   autoUpdateState: false
// })
// scene.add(horse.mesh)




// **************************************************
//
// EFFECTS
//
// **************************************************
// let endEffect = new EndEffect()
// camera.add(endEffect.mesh)

camera.add(smoke.mesh)
// camera.add(confetti.mesh)

let confettisShader = new ConfettisShader({
  confettisNb: 2000,
  sources: [{x: -1.2, y: 0, z: 0, angle: 5}, {x: 1.2, y: 0, z: 0, delay: 0.5, angle: -5}],
  timeStep: (1 / 30),
  colors: ['#4a535a', '#b5c5df', '#1142fe', '#5d409d', '#ef343f', '#3451c9']
})

let s = 200
confettisShader.mesh.scale.set(s, s, s)
confettisShader.mesh.position.y = -100
dashboard.mesh.add(confettisShader.mesh)

// // testing purposes
// setTimeout(() => {
//   console.log('test')
//   confettisShader.enable()
// }, 4000)



// **************************************************
//
// Speed Effect init
//
// **************************************************

let speedLines = new SpeedLines({
  lines: 400
})
speedLines.disable()
player.mesh.add(speedLines.mesh)


// **************************************************
//
// ORIENTATION
//
// **************************************************
// orientation.addListener('player', player.cameraAnchor)
// orientation.addListener('dashboard', dashboard.mesh)



// **************************************************
//
// INTRO
//
// **************************************************
export const animFocus = function (to, time = 1) {
  return new Promise((resolve)=> {
    TweenMax.to(renderer.boxBlurPass.params.delta, time, {
      x: to,
      ease: Cubic.easeOut,
      onComplete: resolve
    })
  })
}

export const playPrepare = function () {

  return new Promise((resolve)=> {
    music.stop()
    sounds.heartbeat.audio.play()

    camera.position.z = -100
    game.renderer.boxBlurPass.params.delta.x = 0
    setTimeout(()=> {
      camera.position.z = 0
      resolve()
    }, 200)
  })
}


export const playIntro = function () {

  music.stop()
  renderer.boxBlurPass.params.delta.x = 100
  camera.rotation.x = THREE.Math.DEG2RAD * 94
  camera.fov = 30
  camera.position.y = 2.5 * config.worldScale
  // camera.position.z = 0.08 * config.worldScale
  camera.position.z = 0.53 * config.worldScale
  // camera.position.z += 0.48
  // camera.rotation.z
  camera.updateProjectionMatrix()
  // track.update(player.state.distance)
  player.model.visible = true
  player.updatePosition()
  player.actions.intro.reset()
  player.actions.intro.setLoop(THREE.LoopOnce) // DBUEG
  player.actions.intro.paused = true

  player.model.position.set(0, 0, 0.2)
  player.model.rotation.set(
    THREE.Math.DEG2RAD * 0,
    THREE.Math.DEG2RAD * 0,
    THREE.Math.DEG2RAD * -6
  )

  lights.ptLight2.intensity = 0.7
  // sounds.breath0.audio.play()
  // sounds.heartbeat.audio.play()
  scrollCta.hide()
  ui.hideDashboard()

  for (let runner of runners) {
    runner.mesh.visible = false
    // runner.fadeInAnim('ready', 0, Math.random() * 3)
  }

  return new Promise((resolve)=> {

    let tl = new TimelineMax({
      onStart: ()=> {
        raf.on('tick', track.updateTextures)
      },
      onComplete: ()=> {

        textService.draw(i18n.t('start'))
          .then(()=> {

            // for (let tile of game.track.tiles) {
            //   if (tile.trackId === 'start') {
            //     tile.audio.crowd_start.fadeTo(0.5, 2)
            //   }
            // }

            if (i18n.locale !== 'en') ctaService.draw(i18n.t('scrollCta'))
            ctaService.animIn()
            scrollCta.show()
            return new Promise((resolve)=> {
              setTimeout(()=> {
                scrollCta.hide(0.6)
                ctaService.animOut(1)
                setTimeout(resolve, 800)
              }, 2500)
            })
          })
          .then(()=> {
            countdown.play()
            setTimeout(()=> {
              raf.removeListener('tick', track.updateTextures)
              resolve()
            }, 3200)
          })
      }
    })

    const introScale = config.introScale
    const introScaleInvert = 1 / config.introScale
    raf.on('tick', player.updateAnimation)
    tl

      .addLabel('unblur')
      .to(renderer.boxBlurPass.params.delta, 2, {
        x: 0,
        ease: Cubic.easeOut,
        onStart: ()=> {

          // IOS ANIM FIX
          player.model.scale.multiplyScalar(introScale)
          track.mesh.scale.multiplyScalar(introScale)
          camera.position.multiplyScalar(introScale)
          fog.far *= introScale
          lights.hemiLight.position.y *= introScaleInvert
          lights.ptLight2.far *= introScaleInvert

          eyelid.open(2)
        },
        onUpdate: ()=> {

        }
      })

      // PLAY ADJUST SHOE
      .addLabel('adjust-shoe')
      .to(camera.rotation, 0.2, {
        onStart: ()=> {
          // sounds.breath1.audio.play()
        },
        onComplete: ()=> {
          player.actions.intro.paused = false
        }
      })

      // .to(camera.rotation,1,{
      //   z: 10 * THREE.Math.DEG2RAD,
      //   ease: Cubic.easeInOut
      // })

      .to(camera.position, 1.5, {
        x: 0.13 * config.worldScale * introScale,
        y: 2.0 * config.worldScale * introScale,
        z: 0.3 * config.worldScale * introScale,
        ease: Cubic.easeInOut
      }, '-=0.3')
      .to(camera.rotation, 1, {})
      // .to(camera.rotation, 1.4, {
      //   x: 94 * THREE.Math.DEG2RAD,
      //   // y: -5 * THREE.Math.DEG2RAD,
      //   ease: Cubic.easeInOut
      // }, '-=1.0')


      // LOOK UP
      .addLabel('look-up')
      .to(camera.rotation, 2.0, {
        x: 0,
        ease: Power1.easeOut,
        delay: 0,
        onStart: ()=> {
          // sounds.breath2.audio.play()
          sounds.heartbeat.audio.fadeTo(0, 2)

          sounds.crowd_start.audio.setVolume(0)
          sounds.crowd_start.audio.play()
          sounds.crowd_start.audio.fadeTo(1, 2)
          // sounds.crowd_start.audio.fadeTo(0, 0)


          setTimeout(()=> {
            player.model.scale.multiplyScalar(introScaleInvert)
            track.mesh.scale.multiplyScalar(introScaleInvert)
            camera.position.multiplyScalar(introScaleInvert)
            fog.far *= introScaleInvert
            lights.hemiLight.position.y *= introScale
            lights.ptLight2.far *= introScale
          }, 400)

        },
        onComplete: ()=> {
          raf.removeListener('tick', player.updateAnimation)
          player.model.visible = false
          track.tiles[0].showEmojis()
          track.tiles[track.tiles.length - 1].showEmojis()
        }
      }, 'look-up')
      .to(camera, 1.5, {
        fov: 60,
        ease: Cubic.easeInOut,
        onUpdate: ()=> {
          camera.updateProjectionMatrix()
        }
      }, 'look-up')
      .to(camera.position, 1, {
        x: 0 * config.worldScale,
        y: 2.25 * config.worldScale,
        z: 0 * config.worldScale,
        ease: Cubic.easeInOut
      }, '-=0.3')
      .to(lights.ptLight2, 1, {
        intensity: 1,
        ease: Cubic.easeIn
      }, 'look-up')



      .addLabel('look-left')
      .to(player.cameraAnchor.rotation, 1, {
        y: THREE.Math.DEG2RAD * 20,
        ease: Cubic.easeInOut
      })

      // LOOK RIGHT
      .addLabel('look-right')
      .to(player.cameraAnchor.rotation, 2, {
        y: THREE.Math.DEG2RAD * -20,
        ease: Cubic.easeInOut
      })

      // LOOK FORWARD
      .addLabel('look-forward')
      .to(player.cameraAnchor.rotation, 1, {
        y: THREE.Math.DEG2RAD * 0,
        ease: Cubic.easeInOut
      })


      // WALK FORWARD
      // .to(player.state, 3, {
      //   distance: config.startDistance,
      //   ease: Cubic.easeInOut,
      //   onStart: ()=> {
      //     ctaService.draw(i18n.t('scrollCta'))
      //     scrollCta.show()
      //     setTimeout(()=> {
      //       scrollCta.hide()
      //     }, 2000)
      //     countdown.play()
      //   },
      //   onUpdate: ()=> {
      //     player.updatePosition()
      //   }
      // })
  })

}





export const playResults = function () {
  state.stage = STAGES.RESULTS



  camera.stopRun()

  TweenMax.to(renderer.zoomBlurPass.params, 1, {
    strength: 0,
    ease: Cubic.easeOut,
    onComplete: ()=> {
      // renderer.composerw.enabled = false
    }
  })

  speedLines.disable()
  smoke.emitter.disable()
  // confettisShader.reset()
  confettisShader.enable()
  // confetti.emitter.enable()

  car.stop()
  bike.stop()

  sounds.crowd_finish.audio.play()
  music.play('results')

  textService.draw(i18n.t('end'))

  controls.destroy()
  player.stop()

  setTimeout(()=> {
    stopGame()
    sounds.crowd_finish.audio.fadeTo(0, 2)
    // music.play('results')

    let query = {
      _duration: Math.round(state.duration)
    }
    if (store.state.wechat.username) query._name = store.state.wechat.username
    if (i18n.locale === 'en') query._locale = 'en'

    if (config.skipResults) return
    router.replace({
      name: 'result',
      params: {
        isAuthor: true
      },
      query: query
    })
  }, 2000)

}




// **************************************************
//
// HELP
//
// **************************************************
let b4helpFov = 0
let helpFovTween
let helpFocusTween
let helpScrollTimeout
const showHelp = function () {
  if (!config.helpModeAvailable) return
  // console.log('show help')
  if (state.help) return
  state.help = true
  showNextHelpMsg()

  clearTimeout(helpScrollTimeout)
  helpScrollTimeout = setTimeout(()=> {
    scrollCta.show()
  }, 1000)
  music.animRate(0.5, 3)


  console.log('showHelp')

  b4helpFov = camera.fov
  if (helpFovTween) helpFovTween.kill()
  helpFovTween = TweenMax.to(camera, 4, {
    fov: 30,
    ease: Cubic.easeOut,
    onUpdate: ()=> {
      camera.updateProjectionMatrix()
    }
  })

  if (helpFocusTween) helpFocusTween.kill()
  helpFocusTween = TweenMax.to(renderer.boxBlurPass.params.delta, 4, {
    x: 5,
    ease: Cubic.easeInOut,
    repeat: -1,
    yoyo: true,
    onStart: ()=> {
      // renderer.composerw.enabled = true
    }
  })


  // KEEP PLAYING HELP MSGS
  // setInterval(()=> {
  //   if (!state.help) return
  //   showNextHelpMsg()
  // }, 8000)
}

const hideHelp = function () {
  if (!state.help) return
  scrollCta.hide()
  state.help = false
  music.animRate(1, 1)

  console.log('hideHelp')

  clearTimeout(helpScrollTimeout)

  helpFovTween.kill()
  helpFovTween = TweenMax.to(camera, 1, {
    fov: b4helpFov,
    ease: Cubic.easeOut,
    onUpdate: ()=> {
      camera.updateProjectionMatrix()
    }
  })

  helpFocusTween.kill()
  helpFocusTween = TweenMax.to(renderer.boxBlurPass.params.delta, 1, {
    x: 0,
    ease: Cubic.easeOut,
    onComplete: ()=> {
      if (state.stage < STAGES.END_START) {
        // renderer.composerw.enabled = false
      }
    }
  })
  // console.log('hide help')
}

// HELP MSG
let helpMsgsIdx = 0
const showNextHelpMsg = function () {
  const msgs = i18n.t('help')
  textService.draw(msgs[helpMsgsIdx])
  helpMsgsIdx++
  if (helpMsgsIdx >= msgs.length) helpMsgsIdx = 0
}







// **************************************************
//
// GAME STATE
//
// **************************************************
export let state = {
  stage: STAGES.INTRO,
  startTime: null,
  duration: 0,
  help: false,
  progress: {
    px: 0, // SET BY CONTROL
    percent: 0 // 0 to 1
  },
  velocity: {
    now: 0, // SET BY CONTROL
    avg: 0,
    max: 0,
    percent: 0
  },
  numInfront: 0,
  stage2: {
    startTime: null,
    duration: null,
    velocity: {
      base: null, // STAGE 1 TOTAL AVERAGE
      avg: null
    },
    charge: 0
  }
}
const initialState = Object.assign({}, state)

const resetState = ()=> {
  state.stage = STAGES.INTRO
  state.startTime = null
  state.duration = 0
  state.progress.px = 0
  state.progress.percent = 0
  state.velocity.now = 0
  state.velocity.avg = 0
  state.velocity.max = 0
  state.velocity.percent = 0
  state.stage2.startTime = null
  state.stage2.duration = null
  state.stage2.velocity.base = null
  state.stage2.velocity.avg = null
  state.stage2.charge = 0
  state.help = false
  scrollCta.hide()
  music.animRate(1, 1)
}


const updateState = function () {
  clock.state.delta = clock.clock.getDelta()
  const now = performance.now()

  state.progress.px = controls.state.px
  state.velocity.now = controls.state.velocity

  // state.progress.percent = Math.min(1, state.progress.px / config.totalPx)
  state.progress.percent = state.progress.px / config.totalPx
  state.duration = now - state.startTime
  state.velocity.avg = state.progress.px / (state.duration / 1000)
  state.velocity.max = Math.max(state.velocity.now, state.velocity.max)
  state.velocity.percent = Math.min(state.velocity.now / config.velocityMax, 1)


  // HELP MODE
  if (controls.state.inactive && !state.help && state.stage < STAGES.END_START) {
    showHelp()
  } else if (!controls.state.inactive && state.help) {
    hideHelp()
  }

  // DISTANCE
  const distanceRounded = Math.round((state.progress.percent) * 42) // COUNT UP
  distance.play(distanceRounded)

  // NUM CPU OVERTAKEN
  state.numInfront = _.countBy(runners, (runner)=> {
    if (runner.state.isPacer) return false
    if (runner.state.isElite) return false
    return runner.state.px > state.progress.px
  }).true || 0

  // console.log(state.numInfront)

  // CAMERA SHAKE
  if (state.stage > STAGES.INTRO && state.stage < STAGES.RESULTS) {
    camera.update(state, controls, track.angles)
    dashboard.update(state, controls, track.angles)
  }

  // STAGE
  switch (state.stage) {

    // ****************************************************************************************
    //
    // STAGE 0
    //
    // ****************************************************************************************
    case STAGES.STAGE0:

      // confetti.emitter.enable()


      // UPDATE LIGHT COLOR
      lights.ptLight2.color.r = lerp(colors.blue.r, colors.red.r, state.velocity.percent)
      lights.ptLight2.color.g = lerp(colors.blue.g, colors.red.g, state.velocity.percent)
      lights.ptLight2.color.b = lerp(colors.blue.b, colors.red.b, state.velocity.percent)

      const vol = Math.max(0, 1 - state.progress.percent / config.stage0Length)
      sounds.crowd_start.audio.setVolume(vol)

      if (state.progress.percent >= config.stage0Length) {
        music.play('stage1')
        state.stage = STAGES.STAGE1
        sounds.crowd_start.audio.setVolume(0)
      }
      break


    // ****************************************************************************************
    //
    // STAGE 1
    //
    // ****************************************************************************************
    case STAGES.STAGE1:

      // UPDATE LIGHT COLOR
      lights.ptLight2.color.r = lerp(colors.blue.r, colors.red.r, state.velocity.percent)
      lights.ptLight2.color.g = lerp(colors.blue.g, colors.red.g, state.velocity.percent)
      lights.ptLight2.color.b = lerp(colors.blue.b, colors.red.b, state.velocity.percent)

      if (state.progress.percent >= config.stage1Length) {

        state.airportReady = true

        // config.maxBaseVelocity * 1.2

        TweenMax.to(config, 2.5, {
          controlsMultiplier: config.controlsMultiplier * 1.2,
          ease: Cubic.easeOut
        })



        // UPDATE STAGE 2 BASE
        state.stage2.velocity.base = state.velocity.avg
        state.stage2.startTime = now

        // FAST
        if (state.numInfront <= config.stage1RankLimit) {

          // config.maxBaseVelocity = 10

          TweenMax.to(renderer.multiPassBloomPass.params, 4, {
            blurAmount: 1,
            ease: Cubic.easeInOut
          })

          lights.animColor(lights.ptLight2, colors.red, 1)
          state.stage = STAGES.STAGE2_FAST
          music.play('stage2_fast')

          for (let i = 0; i < elites.length; i++) {
            let elite = elites[i]
            elite.state.autoUpdateState = false
            elite.turnElite(i)
          }

          // HIDE NON-ELITE RUNNERS
          for (let runner of runners) {
            if (runner.state.isElite) continue
            if (runner.state.isPacer) continue
            // runner.mesh.visible = false //
          }

          // UPDATE ELITES
          track.showStrobe()
          setTimeout(()=> {
            for (let i = 0; i < elites.length; i++) {

              let elite = elites[i]

              let offset
              switch (i) {
                case 0:
                  offset = -0.002
                  break
                case 1:
                  offset = 0
                  break
                case 2:
                  offset = -0.001
                  break
              }
              offset -= 1
              // let offset =  -(0.001 * Math.abs(i - 1)) - 1

              let distance = config.startDistance + player.state.distance + 0.02 + offset
              // let toDistance = config.startDistance + player.state.distance + config.stage2Length - 1 // (0.001 * (i - 1)) - 1
              let toDistance = 2.5

              // console.log(player.state.distance, distance)
              // let toDistance = elite.state.distanceStart + player.state.distance - 0.03 + config.stage2Length - (0.001 * (i - 1)) - 1
              elite.state.px = distance * config.totalPx
              // elite.model.position.x = (i - 1) * config.runnerOffset * 1.3
              elite.state.path = getPath((i - 1) * 1.5)
              elite.state.distance = distance
              elite.state.currDistance = distance
              elite.state.minVel = config.velocityMin + 10
              elite.state.maxVel = 170 // state.velocity.max + 5 + Math.abs(i - 1) * 2
              elite.fadeTo(1, 1)
              elite.state.multiplyVelocity = 1.01
              state.elitesTriggerReady = true

              elite.tween = TweenMax.to(elite.state, 70 * 1.5, {
                distance: toDistance,
                onUpdateParams: ['{self}'],
                onUpdate: (tween)=> {
                  elite.state.px = (tween.target.distance - elite.state.distanceStart) * config.totalPx
                },
                onComplete: ()=> {
                  elite.fadeTo(0, 1).then(()=> {
                    elite.mesh.visible = false
                  })
                }
              })

              // let runner = elites[i]
              // runner.goElite(i)
              // runner.catchUpAndPass(1.6, 0.003 + (0.002 * i), 1000, 1.2)
            }
            dashboard.startStage2()
          }, 10)


        // SLOW
        } else {

          state.airportReady = true

          lights.animColor(lights.ptLight2, colors.blue, 1)
          state.stage = STAGES.STAGE2_SLOW
          // music.play('stage2_slow')
          textService.draw(i18n.t('slow')[1])
            .then(()=> {
              dashboard.startStage2()
            })
        }

      }
      break


    // ****************************************************************************************
    //
    // STAGE 2
    //
    // ****************************************************************************************
    case STAGES.STAGE2_SLOW:
    case STAGES.STAGE2_FAST:

      // let limit = state.progress.px + config.totalPx * 0.01
      // console.log(limit, elites[0].state.px)
      if (state.elitesTriggerReady && state.progress.px >= elites[0].state.px - config.totalPx * 0.004) {
        state.elitesTriggerReady = false
        for (let i = 0; i < elites.length; i++) {
          let elite = elites[i]
          // elite.tween.kill()
          // elite.state.autoUpdateState = true
          // TweenMax.to(elite.state, 8, {
          //   // multiplyVelocity: 1.1,
          //   maxVel: state.velocity.max + 50 + Math.abs(i - 1) * 10,
          //   ease: Cubic.easeIn
          // })
          let duration = 40
          switch (i) {
            case 0:
              duration -= 0
              break
            case 1:
              duration -= 2
              break
            case 2:
              duration -= 1
              break
          }
          duration *= 1.5
          TweenMax.to({duration: elite.tween.duration()}, 1, {
            duration: duration,
            onUpdateParams: ['{self}'],
            ease: Power1.easeIn,
            onUpdate: (tween)=> {
              elite.tween.duration(tween.target.duration)
            },
            onComplete: ()=> {
              // setTimeout(()=> {
              //   elite.fadeTo(0, 1)
              //   elite.mesh.visible = false
              // }, 5000)
            }
          })

        }
        setTimeout(()=> {
          textService.draw(i18n.t('fast')[1])
        }, 200)

      }

      renderer.zoomBlurPass.params.strength = Math.min(state.velocity.percent * 0.07, 0.07)
      state.stage2.duration = now - state.stage2.startTime
      state.stage2.velocity.avg = (state.progress.px - config.totalPx * config.stage1Length) / (state.stage2.duration / 1000)
      state.stage2.charge = Math.max(state.stage2.velocity.avg / state.stage2.velocity.base - 1, 0) / (config.breakScale - 1.0)
      state.stage2.charge = Math.min(state.stage2.charge, (state.progress.percent - config.stage1Length) / config.stage2Length )
      if (state.stage === STAGES.STAGE2_SLOW) {
        state.stage2.charge = Math.min(state.stage2.charge, (state.numInfront / config.numRunners))
      }


      if (state.airportReady && state.progress.percent >= 0.56) {
        state.airportReady = false
        music.play('airport')
        textService.draw(i18n.t('airport'))
        TweenMax.to(config, 1, {
          controlsMultiplier: config.controlsMultiplier * 1.1,
          ease: Cubic.easeOut
        })
        TweenMax.to(renderer.multiPassBloomPass.params, 1.5, {
          blurAmount: 2,
          ease: Cubic.easeInOut
        })
      }

      if (state.progress.percent >= (config.stage1Length + config.stage2Length)) {

        // SPEED WORLD ENDING
        if (state.stage2.charge >= 1) {

          state.stage = STAGES.END_START

          // config.maxBaseVelocity *= 1.05 // PRO LONG SEQ
          TweenMax.to(config, 1, {
            controlsMultiplier: config.controlsMultiplier * 1.15,
            ease: Cubic.easeOut
          })


          car.state.distance = config.stage1Length + config.stage2Length - 0.05
          bike.state.distance = config.stage1Length + config.stage2Length - 0.05

          car.state.currDistance = car.state.distance
          bike.state.currDistance = bike.state.distance

          car.model.visible = true
          bike.model.visible = true

          for (let runner of runners) {
            // runner.mesh.visible = false
          }

          textService.draw(i18n.t('10kmCta'))

          lights.animColor(lights.ptLight2, colors.red, 1)
          music.play('end')

          let tl = new TimelineMax()
          let time = 1
          tl
            .to({}, 1, {})

            .addLabel('start')
            .to(renderer.multiPassBloomPass.params, time, {
              blurAmount: 3.5,
              ease: Cubic.easeOut,
              onStart: ()=> {
                // renderer.composerw.enabled = true
                speedLines.enable(time)
                sounds.sonic_boom.audio.playPromise()
                // renderer.multiPassBloomPass.enabled = true
              }
            }, 'start')
            .to(renderer.zoomBlurPass.params, time, {
              strength: 0.1,
              ease: Cubic.easeIn,
              delay: 0
              // onStart: ()=> {
              //   music.play('end')
              // }
            }, 'start')
            .to(camera, 1, {
              delay: 0,
              fov: 97,
              ease: Cubic.easeIn,
              onUpdate: ()=> {
                camera.updateProjectionMatrix()
              }
            }, 'start')

        // SLOW ENDING
        } else {

          for (let elite of elites) {
            elite.mesh.visible = false
          }
          car.model.visible = true
          bike.model.visible = true

          state.stage = STAGES.END_NORMAL

          // CAR
          car.model.position.x = 6 * config.worldScale
          car.state.distance = config.stage1Length + config.stage2Length + 0.12
          car.model.rotation.y = THREE.Math.DEG2RAD * -145

          // BIKE
          bike.model.position.x = -5 * config.worldScale
          bike.state.distance = config.stage1Length + config.stage2Length + 0.18
          bike.model.rotation.y = THREE.Math.DEG2RAD * -45

          // LIGHTS
          lights.animColor(lights.ptLight2, colors.blue, 1)
        }
      }
      break


    // ****************************************************************************************
    //
    // SPEED WORLD CUT SCENE
    //
    // ****************************************************************************************
    case STAGES.END_START:

      renderer.multiPassBloomPass.params.strength = Math.min(state.velocity.percent * 3.5, 3.5)
      renderer.zoomBlurPass.params.strength = Math.min(state.velocity.percent * 0.1, 0.1)

      if (state.progress.percent >= (config.stage1Length + config.stage2Length + 0.055)) {

        // CATCH UP N PASS
        // car.catchUpAndPass(3, 3, 0.000001, 250, 1.01)
        car.runToEnd(player.state.distance - 0.012, 20, SlowMo.ease.config(0.2, 0.8))
        // car.toUserFront(4, -0.01, 0.01)

        car.audio.car.play()
        smoke.emitter.enable()
        state.stage = STAGES.END_SPEED


        // TWEEN TO END
        // let fromDistance = player.state.distance - 0.01
        // let toDistance = player.state.distance + 0.06
        // car.state.autoUpdateState = false
        // car.state.px = fromDistance * config.totalPx
        // car.state.distance = fromDistance

        // let tl = new TimelineMax()
        // tl
        //   .to(car.state, 5, {
        //     distance: toDistance,
        //     ease: Cubic.easeInOut,
        //     onUpdateParams: ['{self}'],
        //     onUpdate: (tween)=> {
        //       car.state.px = (tween.target.distance - car.state.distanceStart) * config.totalPx
        //     }
        //   })
        //   .to(car.state, 10, {
        //     distance: 2.1,
        //     ease: Cubic.easeIn,
        //     onUpdateParams: ['{self}'],
        //     onUpdate: (tween)=> {
        //       car.state.px = (tween.target.distance - car.state.distanceStart) * config.totalPx
        //     }
        //   })
        // let distance = config.startDistance + player.state.distance + 0.02 + offset
        // let toDistance = config.startDistance + player.state.distance + config.stage2Length - 1 // (0.001 * (i - 1)) - 1
        // car.state.px = distance * config.totalPx
        // car.model.position.x = (i - 1) * config.runnerOffset * 1.3
        // car.state.distance = distance
        // car.state.minVel = config.velocityMin + 10
        // car.state.maxVel = 170 // state.velocity.max + 5 + Math.abs(i - 1) * 2
        // car.fadeTo(1, 1)
        // car.state.multiplyVelocity = 1.01
        // state.carsTriggerReady = true

        // car.tween = TweenMax.to(car.state, 30, {
        //   distance: toDistance,
        //   onUpdateParams: ['{self}'],
        //   onUpdate: (tween)=> {
        //     car.state.px = (tween.target.distance - car.state.distanceStart) * config.totalPx
        //   }
        // })





        // SLOW MO
        // let tl = new TimelineMax()
        // let slowMoTime = 3.5
        // tl
        //   .addLabel('vehicle')
        //   .to({}, 0.8, {
        //     delay: 0,
        //     onStart: ()=> {
        //       car.playAnim(4.5)
        //     }
        //   })

        //   .addLabel('slowmo')
        //   .to(controls.state, slowMoTime, {
        //     multiplier: 0.2,
        //     ease: SlowMo.ease.config(0.6, 0.8, true),
        //     onStart: ()=> {
        //       smoke.emitter.enable()
        //       camera.stopRun()
        //       sounds.sonic_boom.audio.playPromise()
        //       music.animRate(0.5, 1)
        //       setTimeout(()=> {
        //         car.audio.car.play()
        //       }, 1000)
        //       setTimeout(()=> {
        //         music.animRate(1, slowMoTime * 0.2)
        //       }, slowMoTime * 0.8)
        //     },
        //     onComplete: ()=> {
        //       config.maxBaseVelocity *= 1
        //       config.velocityMin = 50
        //       state.stage = STAGES.END_SPEED
        //       music.play('end')
        //       camera.startRun()
        //     }
        //   })
        //   .to(renderer.zoomBlurPass.params, slowMoTime, {
        //     strength: 0.05,
        //     ease: SlowMo.ease.config(0.6, 0.8, true),
        //     delay: 0
        //   }, 'slowmo')
        //   .to(camera, slowMoTime, {
        //     delay: 0,
        //     fov: 75,
        //     ease: SlowMo.ease.config(0.6, 0.8, true),
        //     onUpdate: ()=> {
        //       camera.updateProjectionMatrix()
        //     }
        //   }, 'slowmo')


      }

      break

    // case STAGES.END_CAR:
    //   break

    case STAGES.END_SPEED:

      renderer.multiPassBloomPass.params.blurAmount = Math.min(state.velocity.percent * 5, 5)
      renderer.zoomBlurPass.params.strength = Math.min(state.velocity.percent * 0.2, 0.2)
      smoke.update(clock.state.delta * (1 - state.velocity.percent))

      if (state.progress.percent >= (config.stage1Length + config.stage2Length + 0.09)) {
        state.stage = STAGES.END_BIKE
        state.crowdFinishReady = true
        music.play('end_fast')
        // bike.autoUpdateState = true
        // bike.catchUpAndPass(3, 3, 0.000001)
        bike.runToEnd(player.state.distance - 0.005, 20, SlowMo.ease.config(0.2, 0.8))
        // bike.toUserFront(4, -0.01, 0.01)
        bike.audio.bike.play()

        // TweenMax.to(camera, 1, {
        //   delay: 0,
        //   fov: 97,
        //   ease: Cubic.easeIn,
        //   onUpdate: ()=> {
        //     camera.updateProjectionMatrix()
        //   }
        // })

        let rotStart = new THREE.Vector3(0, THREE.Math.DEG2RAD * 180, 0)
        TweenMax.to(bike.model.rotation, 2, {
          x: `-=${THREE.Math.DEG2RAD * 50}`,
          ease: SlowMo.ease.config(0.8, 0.5, true)
        })
      }
      break


    case STAGES.END_BIKE:
      renderer.multiPassBloomPass.params.blurAmount = Math.min(state.velocity.percent * 6, 6)
      renderer.zoomBlurPass.params.strength = Math.min(state.velocity.percent * 0.25, 0.25)
      smoke.update(clock.state.delta * (1 - state.velocity.percent))


      if (state.crowdFinishReady && state.progress.percent >= 0.95) {
        smoke.emitter.disable()
        speedLines.disable()
      }

      if (state.crowdFinishReady && state.progress.percent >= 0.96) {
        state.crowdFinishReady = false
        sounds.crowd_finish.audio.play()
        // sounds.crowd_finish.audio.setVolume(0.001)
        // sounds.crowd_finish.audio.fadeTo(1, 7)
      }

      if (state.progress.percent >= 0.978) {
        state.stage = STAGES.END_LINE
      }
      break

    case STAGES.END_LINE:

      state.stage = STAGES.RESULTS



      let tl = new TimelineMax()
      let slowMoTime = 3
      state.stage = STAGES.RESULTS
      tl
        // .addLabel('slowmo')
        // .to(controls.state, slowMoTime, {
        //   multiplier: 0.2,
        //   ease: SlowMo.ease.config(0.6, 0.8, true),
        //   onStart: ()=> {
        //     smoke.emitter.disable()
        //     camera.stopRun()
        //     music.animRate(0.5, 1)
        //     setTimeout(()=> {
        //       music.animRate(1, slowMoTime * 0.2)
        //     }, slowMoTime * 0.8)
        //   },
        //   onComplete: ()=> {
        //     state.stage = STAGES.RESULTS
        //   }
        // })

        .addLabel('reality')
        .to(renderer.multiPassBloomPass.params, 1, {
          blurAmount: 0,
          ease: Cubic.easeOut,
          onStart: ()=> {
            camera.stopRun()
            controls.stop(3)
              .then(camera.stopRun)
          }
        }, 'reality')
        .to(renderer.zoomBlurPass.params, 1, {
          strength: 0,
          ease: Cubic.easeOut
        }, 'reality')
        .to(camera, 1, {
          fov: 60,
          ease: Cubic.easeOut,
          onUpdate: ()=> {
            camera.updateProjectionMatrix()
          },
          onComplete: ()=> {

            setTimeout(()=> {
              playResults()
            }, 700)
          }
        }, 'reality')


      break

    // ****************************************************************************************
    //
    // ENDING
    //
    // ****************************************************************************************
    case STAGES.END_NORMAL:
      checkGameEnd()
      break

    case STAGES.RESULTS:
      // console.log('result')
      smoke.update()

      resultCloth.update()
      break
  }



}


const checkGameEnd = function () {
  if (state.progress.percent >= 1) {
    playResults()
  }
}




const updateGame = function (delta) {
  updateState(delta)
  controls.update(delta)

  track.update(delta)
  player.update(delta)
  car.update(delta)
  bike.update(delta)
  for (let runner of runners) {
    runner.update(delta)
  }

  lights.dirLight.position.x = player.mesh.position.x
  lights.dirLight.position.y = 240 + state.progress.percent * 80

  speedLines.update(delta)
}



const startGame = function () {

  clock.clock.stop()
  clock.clock.start()

  camera.startRun()

  player.model.visible = false
  player.distance = config.startDistance

  track.startSound(0)
  track.hideStrobe()
  // orientation.recalibrate()
  music.play('stage0')
  camera.rotation.x = THREE.Math.DEG2RAD * 0
  camera.fov = 60
  camera.updateProjectionMatrix()
  eyelid.open(0)
  renderer.boxBlurPass.params.delta.x = 0
  state.startTime = performance.now()
  state.stage = STAGES.STAGE0
  console.log('startGame')


  controls.init()
  car.start()
  bike.start()
  player.start()
  for (let runner of runners) {
    runner.start()
  }

  raf.on('tick', updateGame)
  ui.showDashboard()

  // LOOK LEFT
  // let tl = new TimelineMax()
  // tl
  //   .addLabel('look-left')
  //   .to(player.cameraAnchor.rotation, 1, {
  //     delay: 1.5,
  //     y: THREE.Math.DEG2RAD * 20,
  //     ease: Cubic.easeInOut
  //   })


  //   // LOOK RIGHT
  //   .addLabel('look-right')
  //   .to(player.cameraAnchor.rotation, 2, {
  //     y: THREE.Math.DEG2RAD * -20,
  //     ease: Cubic.easeInOut
  //   })


  //   // LOOK FORWARD
  //   .addLabel('look-forward')
  //   .to(player.cameraAnchor.rotation, 1, {
  //     y: THREE.Math.DEG2RAD * 0,
  //     ease: Cubic.easeInOut,
  //     onComplete: ()=> {
  //       ui.showDashboard()
  //     }
  //   })
}










// **************************************************
//
// METHODS
//
// **************************************************
export const stopGame = function () {
  raf.removeListener('tick', updateGame)
  controls.destroy()
}

const resetGame = function () {

  config.reset()
  dashboard.reset()

  car.stop()
  bike.stop()

  // car.fadeTo(0, 0)
  // bike.fadeTo(0, 0)
  car.model.visible = false
  bike.model.visible = false

  // for (let elite of elites) {
  //   elite.fadeTo(0, 0)
  // }

  renderer.multiPassBloomPass.blurAmount = 0
  renderer.zoomBlurPass.params.strength = 0
  renderer.setRenderGame(true)
  renderer.setRenderResults(false)

  // EFFECTS
  smoke.emitter.disable()
  speedLines.disable()
  smoke.group.tick(10000)
  lights.animColor(lights.ptLight2, colors.blue, 0)

  controls.reset()
  camera.stopRun()
  player.reset()
  for (let runner of runners) {
    runner.reset()
  }
  resetState()
}

export const restartGame = function () {

  player.checkAllLoaded()
  car.checkAllLoaded()
  bike.checkAllLoaded()
  for (let runner of runners) {
    runner.checkAllLoaded()
  }

  stopGame()
  resetGame()
  music.stop()

  // PLAY INTRO THEN START
  if (!config.skipIntro) {
    playPrepare()
      .then(playIntro)
      .then(startGame)

  } else {

    // START IMMEDIATELY
    startGame()

    // SKIP TO SPEED WORLD
    if (config.skipToSpeedWorld) {
      music.play('end_fast')
      // music.animRate(0.8, 0)
      state.stage = STAGES.STAGE2_FAST
      controls.state.baseVelocity = 30
      controls.state.px = config.totalPx * (config.stage1Length + config.stage2Length - 0.08)

    // SKIP TO SLOW WORLD
    } else if (config.skipToSlowWorld) {
      state.stage = STAGES.STAGE2_SLOW
      controls.state.baseVelocity = 8
      controls.state.px = config.totalPx * (config.stage1Length + config.stage2Length - 0.01)
      runners[0].state.autoUpdateState = false
      runners[0].state.distance = config.startDistance + 0.99

    // SKIP TO STAGE 2
    } else if (config.skipToStage2) {
      controls.state.baseVelocity = 13
      controls.state.px = config.totalPx * (config.stage1Length - 0.01)
    }
  }


}


// **************************************************
//
// WORLD SCALE
//
// **************************************************
// for (let child of scene.children) {
//   child.scale.multiplyScalar(config.worldScale)
// }





// **************************************************
//
// EXPORT
//
// **************************************************
const game = {

  // GAME
  renderer: renderer,
  clock: clock,
  controls: controls,
  // orientation: orientation,
  scene: scene,
  lights: lights,
  camera: camera,
  loader: loader,
  raf: raf,

  // UI
  uiCamera: uiCamera,
  ui: ui,
  text: textService,
  countdown: countdown,
  distance: distance,
  cta: ctaService,
  scrollCta: scrollCta,
  eyelid: eyelid,
  dashboard: dashboard,

  // OBJECTS
  path: path,
  sky: sky,
  buildings: buildings,
  track: track,
  player: player,
  runners: runners,
  elites: elites,
  car: car,
  bike: bike,

  // EFFECTS
  smoke: smoke,
  speedLines: speedLines,
  confettisShader: confettisShader,
  // confetti: confetti,

  // STATE
  config: config,
  state: state,
  initialState: initialState,

  // METHODS
  restart: restartGame,
  stop: stopGame,
  start: startGame,
  playIntro: playIntro,
  playResults: playResults,
  animFocus: animFocus,

  // SOUNDS
  // music: MusicService,
  music: music,
  listener: listener,
  sounds: sounds,


  // RESULTS
  result: {
    scene: resultScene,
    bg: resultBg,
    flag: resultFlag,
    cloth: resultCloth
  }

}

export default game
window.game = game




// WEBPACK FOOTER //
// ./src/components/game/main.js